import { trackWidgetOpened } from 'events/analytics';
import { uiEventTypes } from 'events/ui';

// Allowed values for `trigger` attribute, which indicates how the widget open
// event was triggered:
// - Note that the source of truth for these allowed values can be found in the
//   schema definition of the analytics event in https://github.com/sagansystems/snowplow-schemas/tree/master/schemas/com.gladly.sidekick/event_widget_opened/jsonschema
// - When the schema is updated, make sure to update these values here.
// - Values for `trigger` will be validated by snowplow, so no validation is
//   conducted here.
export const WIDGET_OPENED_TRIGGER_API = 'api'; // triggered programatically by a call to Gladly's show API.
export const WIDGET_OPENED_TRIGGER_MANUAL = 'manual'; // manually opened by the customer
export const WIDGET_OPENED_TRIGGER_PROACTIVE_RULE = 'proactive_rule'; // triggered by a proactive rule

export default function unminimizeWidget(trigger) {
  return dispatch => {
    // track analytics event
    dispatch(trackWidgetOpened({ trigger }));

    dispatch({ type: uiEventTypes.WIDGET_UNMINIMIZE });
  };
}
